import { styled } from "@mui/material/styles";
import { ListItem } from "@mui/material";
import Colors from "../../../../general/constants/colors";
import BreakPoints from "../../../../general/constants/breakPoints";

type BarContainerProp = {
	isVisible: boolean;
};

export const BarContainer = styled("div")<BarContainerProp>(
	({ isVisible = false }) => ({
		display: isVisible ? "flex" : "none",
		justifyContent: "center",
		position: "fixed",
		zIndex: 2,
		backgroundColor: Colors.WHITE,
		boxShadow: "0px 4px 16px 0px #7474741F",
		width: "100%",
		left: 0,
		bottom: 0,
		[`@media (max-width: ${BreakPoints.TABLET_1023}px)`]: {
			display: "flex",
		},
	})
);

export const BarItem = styled(ListItem)({
	paddingLeft: "2px",
	paddingRight: "2px",
	cursor: "pointer",
	display: "flex",
	justifyContent: "center",
});

export const BarItemText = styled("span")({
	fontSize: "13px",
	color: Colors.BLACK,
	height: "30px",
	[`@media (max-width: ${BreakPoints.MOBILE_768}px)`]: {
		fontSize: "12px",
	},
	[`@media (max-width: ${BreakPoints.TAPOK_319}px)`]: {
		fontSize: "11px",
	},
});

export const LinkWrapper = styled("a")({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	textAlign: "center",
});
